import { BaseEntity } from '../../../app/core';

export class SelectList extends BaseEntity {
    description: string;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/selectList.ts